// extracted by mini-css-extract-plugin
export var content = "_b2-3";
export var list = "_b2-4";
export var settingsContent = "_b2-7";
export var settingsPanel = "_b2-8";
export var state = "_b2-6";
export var triggerBadge = "_b2-2";
export var triggerButton = "_b2-1";
export var triggerShell = "_b2-0";
export var unreadDot = "_b2-5";